import React, { Component } from "react";
import Avatar from "@mui/material/Avatar";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import moment from "moment";
import { Menu, MenuItem } from "@mui/material";
import { Button, Form, Modal } from "react-bootstrap";
import ManageUserService from "../../api/ManageUserService";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AuthService from "../../session/AuthService";
import DeleteUserModal from "../Modal/DeleteUserModal";

class EmployeeGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      selectedEditData: {},
      opendeleteproductDialogue: false,
    };
  }

  render() {
    return (
      <>
        {/* <Loader/> */}
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Employee Name</th>
                  {String(AuthService.getUserTypeAdmin()) === "3" && (
                    <>
                  {this.props.isAdmin && <th>Employeer Name</th>} 
                      <th>Email</th>
                      <th>MobileNo</th>
                    </>
                  )}
                  <th>Joined date and time</th>
                  <th>Last Active</th>
                  {String(AuthService.getUserTypeAdmin()) !== "3" && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {this.props.userList.map((e) => (
                  <tr key={e.id}>
                    <td class="avatar-cell">
                      <div class="avatar">
                        <Avatar>{e.firstName.charAt(0).toUpperCase()}</Avatar>
                        <div class="name">
                          {e.firstName.charAt(0).toUpperCase() +
                            e.firstName.slice(1)}
                          {e.lastName ? " " + e.lastName : ""}

                          {!this.props.isAdmin && AuthService.getUserTypeAdmin() === "3" && e.userType === "1" && <small className="fs-6"><em> (Employer)</em></small>}
                        </div>
                      </div>
                    </td>
                    {String(AuthService.getUserTypeAdmin()) === "3" && (
                      <>
                      {this.props.isAdmin && <td> 
                          {e.employerFirstName?.charAt(0).toUpperCase() +
                            e.employerFirstName?.slice(1)}
                          {e.employerLastName ? " " + e.employerLastName : ""}
                        </td>}
                        <td>{e.email}</td>
                        <td>{e.phoneNo}</td>
                      </>
                    )}

                    <td>
                      {moment(e.createdDate).format("MMMM DD, YYYY, hh:mm A")}
                    </td>
                    <td>
                      {e.lastLogin
                        ? moment(e.lastLogin).format(
                            "MMMM DD, YYYY, hh:mm A"
                          )
                        : "No login recorded"}
                    </td>
                    {String(AuthService.getUserTypeAdmin()) !== "3" && (
                      <td>
                        {
                          <>
                            <MoreHorizIcon
                              onClick={(event) =>
                                this.handleFilterClick(event, e)
                              }
                            />{" "}
                            <Menu
                              anchorEl={this.state.anchorEl}
                              open={Boolean(this.state.anchorEl)}
                              onClose={this.handleFilterClose2}
                              className="exclude-menu"
                            >
                              <MenuItem
                                onClick={(e) =>
                                  this.handleFilterClose("edit", e)
                                }
                              >
                                <EditOutlinedIcon />{" "}
                                <span className="inisde-the-action">Edit</span>
                              </MenuItem>

                              <MenuItem
                                onClick={() => this.handleFilterClose("delete")}
                              >
                                <DeleteOutlinedIcon />{" "}
                                <span className="inisde-the-action">
                                  Delete
                                </span>
                              </MenuItem>
                            </Menu>
                          </>
                        }
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
              {this.props.userList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
        </div>
        {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
      </>
    );
  }
  handleFilterClick = (event, data) => {
    console.log("event", event, data);
    this.setState({
      anchorEl: event.target,
      selectedEditData: data,
    });
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (getState) => {
    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
    } else if (getState === "delete") {
      this.setState({
        opendeleteproductDialogue: true,
        anchorEl: null,
      });
    }
  };

  handleClose = () => {
    this.setState({ opendeleteproductDialogue: false });
  };

  deleteUser = () => {
    let obj = {
      id: this.state.selectedEditData.id,
    };

    ManageUserService.deleteUser(obj).then((response) => {
      if (response.data) {
        this.handleClose();
        this.props.onLoad();
      }
    });
  };

  deleteproductPopUp = () => {
    console.log("state id deleteproductPopUp", this.state.product_id);
    return (
      <DeleteUserModal
        handleClose={this.handleClose}
        deleteUser={this.deleteUser}
      />
    );
  };
}
export default EmployeeGrid;
